define('views/modules/calendar/animated-session/animation/modal/delete-custom-exercise-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    'services/i18n',
    // views
    'views/parts/modal/modal'

], function(
    // Libs
    _, Backbone, Mustache, U, i18n,
    // views
    VModal
) {

    var VDeleteCustomExerciseModal = VModal.extend({

        template: '<p>{{#t}}general:delete-custom-exercise-modal-body{{/t}}</p>',

        modal: function() {
            return {
                title: i18n.t('general:delete-custom-exercise-modal-title'),
                buttons: {
                    cancel: {
                        label: i18n.t("Cancel"),
                        callback: this.onCancel,
                    },
                    confirm: {
                        label: i18n.t("Ok"),
                        callback: this.onConfirm
                    },
                },
            };
        },

        initialize: function(options) {
            this.model = options.model;
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            return this.renderModal();
        },

        onConfirm: function() {
            this.model.trigger('delete:confirmed');
        }

    });

    return VDeleteCustomExerciseModal;
});

